var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccessTokens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 85,
    viewBox: "0 0 216 85",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.054 5 98.833 45.74c-6.73-2.92-14.833-1.86-20.64 3.368-7.934 7.144-8.575 19.367-1.43 27.3l.817.91c7.144 7.933 19.367 8.574 27.301 1.43 7.55-6.797 8.495-18.193 2.415-26.118l16.918-17.573 7.108-7.382 3.136 3.041 1.229-1.278 1.102 1.07 2.457-2.557 3.858 3.742 7.373-7.669-2.205-2.138 3.072-3.195-5.882-5.704 2.613-2.714A5.453 5.453 0 0 0 149.394 5h57.552c5 0 9.054 3.582 9.054 8s-4.054 8-9.054 8H155.21c5 0 9.053 3.582 9.053 8s-4.053 8-9.053 8h28.455c5 0 9.054 3.582 9.054 8s-4.054 8-9.054 8h-13.16c-6.304 0-11.415 3.582-11.415 8 0 2.946 2.587 5.612 7.76 8 5 0 9.054 3.582 9.054 8s-4.053 8-9.054 8H59.497c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8H9.054C4.054 69 0 65.418 0 61s4.054-8 9.054-8H60.79c5 0 9.054-3.582 9.054-8s-4.053-8-9.054-8H28.455c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8h51.737c-5 0-9.054-3.582-9.054-8s4.053-8 9.054-8h57.862Zm68.892 48c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8S216 40.582 216 45s-4.054 8-9.054 8Z",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-42 112.85 -50.643)",
    stroke: "#6A6666",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.64 21.452 59.9-4.3a4.384 4.384 0 0 0 4.06-4.672 4.343 4.343 0 0 0-4.625-4.038h-.01l-.008.001-60.26 4.327.943 8.682Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.045 18.427.41 6.086 1.817-.131.102 1.521 3.634-.263.36 5.326 10.901-.79-.205-3.042 4.543-.33-.667-9.89"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 37.226,
    height: 38.671,
    rx: 18.613
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.474 17.08a3.118 3.118 0 0 0-2.764 3.413l.03.307a3.053 3.053 0 0 0 3.37 2.728 3.118 3.118 0 0 0 2.764-3.414l-.032-.307c0-.012 0-.012-.002-.023a3.053 3.053 0 0 0-3.366-2.705Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessTokens);
export default __webpack_public_path__ + "static/media/access-tokens.2e7e731b260be4522e8c37da9494b5bd.svg";
export { ForwardRef as ReactComponent };